import React from 'react';
import { Link } from 'react-router-dom';

export default function Confidentialite() {
  return (
    <>
      <section className="bg-slate-900 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-sm text-slate-400 mb-4 flex items-center gap-2">
            <Link to="/" className="hover:text-orange-400">Accueil</Link><span>/</span>
            <span className="text-white">Politique de confidentialité</span>
          </div>
          <h1 className="text-3xl font-extrabold text-white">Politique de confidentialité</h1>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate">

          <p>Dernière mise à jour : avril 2026</p>

          <h2>Responsable du traitement</h2>
          <p>
            <strong>Apex Rénovation</strong>, SAS<br />
            SIRET : 102 941 028 00015 — RCS Châteauroux<br />
            2 rue du Gué de la Chapelle, 36250 Saint-Maur<br />
            Email : <a href="mailto:contact@apexrenovation.fr">contact@apexrenovation.fr</a>
          </p>

          <h2>Données collectées</h2>
          <p>Nous collectons les données suivantes uniquement lorsque vous nous les communiquez volontairement (formulaire de contact, configurateur de devis) :</p>
          <ul>
            <li>Prénom et nom</li>
            <li>Adresse email</li>
            <li>Numéro de téléphone</li>
            <li>Adresse du chantier (facultatif)</li>
            <li>Informations relatives à votre projet de rénovation</li>
          </ul>
          <p>Nous ne collectons aucune donnée sensible au sens du RGPD.</p>

          <h2>Finalité et base légale</h2>
          <p>Vos données sont utilisées exclusivement pour :</p>
          <ul>
            <li>Répondre à vos demandes de devis et vous transmettre votre estimation (intérêt légitime / exécution d'un contrat)</li>
            <li>Vous contacter dans le cadre du suivi de votre projet (intérêt légitime)</li>
          </ul>
          <p>Vos données ne sont pas utilisées à des fins de prospection commerciale sans votre accord explicite.</p>

          <h2>Durée de conservation</h2>
          <p>
            Vos données sont conservées pendant une durée maximale de 3 ans à compter de votre dernier contact, puis supprimées ou anonymisées.
          </p>

          <h2>Destinataires</h2>
          <p>
            Vos données sont traitées par Apex Rénovation SAS et ne sont pas cédées à des tiers à des fins commerciales. Elles peuvent être transmises à nos prestataires techniques (hébergeur, service d'envoi d'emails) dans le strict cadre de la fourniture du service.
          </p>

          <h2>Cookies</h2>
          <p>
            Ce site n'utilise pas de cookies de traçage ou publicitaires. Aucun outil de mesure d'audience tiers n'est déployé sur ce site.
          </p>

          <h2>Vos droits</h2>
          <p>Conformément au RGPD (Règlement UE 2016/679) et à la loi Informatique et Libertés, vous disposez des droits suivants :</p>
          <ul>
            <li>Droit d'accès à vos données</li>
            <li>Droit de rectification</li>
            <li>Droit à l'effacement (« droit à l'oubli »)</li>
            <li>Droit à la limitation du traitement</li>
            <li>Droit à la portabilité</li>
            <li>Droit d'opposition</li>
          </ul>
          <p>
            Pour exercer ces droits, contactez-nous à <a href="mailto:contact@apexrenovation.fr">contact@apexrenovation.fr</a>. Vous pouvez également introduire une réclamation auprès de la CNIL (<a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>).
          </p>
        </div>
      </section>
    </>
  );
}
